import moment from "moment-timezone";
import * as Sentry from '@sentry/react';
 
 const hasKeyAndValue=(data,key)=>{
     return data[key]&&data[key].length>0 
   }
export const validateData=(data,keyArray=[])=>{
  let isValid=true;
  let reason=""
  if(typeof data=="object"&&Object.keys(data).length>0){
      if(keyArray&&Array.isArray(keyArray)){
        keyArray.forEach(item=>{

            if(!hasKeyAndValue(data,item)){
                isValid=false
                reason=`${item} unavailable`
            }
          })  
      }
  }else{
      isValid =false
  }
  return {isValid,reason};
}

export  function isValidDateTime(dateTime) {
  return moment(dateTime, moment.ISO_8601, true).isValid();
}


export const isDisabledForMe = (assignment, my_id) => {
  try {
    if (assignment && Array.isArray(assignment.deactivated_student)) {
      return assignment.deactivated_student.includes(my_id)
    }
    return false
  } catch (error) {
    Sentry.captureException(`662 Error in isDisabledForMe: ${error}`);
    console.error(error, ":error in disabled assignment")
    return false
  }
}